import { Connection } from 'utils';
import { GET_POSTBACK_CHANGE_LOG } from 'constants/api';

export default {
  getPostbackChangeLog: filter => Connection.post(GET_POSTBACK_CHANGE_LOG, filter),
};
